"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultNavigationCard = ResultNavigationCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@kalkulacka-one/design-system/client");
const next_intl_1 = require("next-intl");
function ResultNavigationCard({ onNextClick }) {
    const t = (0, next_intl_1.useTranslations)("koa.components.resultNavigationCard");
    return ((0, jsx_runtime_1.jsx)("div", { className: "koa:flex koa:justify-center koa:sm:justify-start", children: (0, jsx_runtime_1.jsx)(client_1.Button, { variant: "pill", color: "neutral", onClick: onNextClick, children: t("compareButton") }) }));
}
